module.exports = __webpack_public_path__ + "static/ofcar2-37140a426bbac479195580f6cd70cc0e.jpg";